// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 498) return "static/chunks/498-65bfb71561e1ec03.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 846 ? "59ae8a9c" : chunkId) + "." + {"568":"a429d696d87c0b5a","846":"41921c5a2bb8e2c9"}[chunkId] + ".js";
};